module.exports = __webpack_public_path__ + "static/media/enablon-logo.d54f10d3.png";